import React, { useMemo } from "react";

import { Container, Row, Col } from "react-bootstrap";
import { MDBDataTableV5 } from "mdbreact";
import CustomGreenButton from "../../../components/shared/custom-green-button";
import TvIcon from "@material-ui/icons/Tv";
import PersonIcon from "@material-ui/icons/Person";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import { useHistory, useLocation } from "react-router-dom";

const USER_TABLE_COLUMNS = [
  {
    label: "#",
    field: "index",
    sort: "asc",
    width: 50,
  },
  {
    label: "Username",
    field: "username",
    sort: "asc",
  },
  {
    label: "Email",
    field: "email",
    sort: "asc",
  },
  {
    label: "Nombre",
    field: "nombreCliente",
    sort: "asc",
  },
  {
    label: "Boletín",
    field: "boletin",
    sort: "asc",
  },
  {
    label: "Mayor de edad",
    field: "mayorEdad",
    sort: "asc",
  },
  {
    label: "País",
    field: "paisIndividual",
    sort: "asc",
  },
  {
    label: "Fecha creación",
    field: "fechaCreacion",
    sort: "asc",
  },
  {
    label: "Celular",
    field: "celular",
    sort: "asc",
  },
  {
    label: "Identificador",
    field: "identificador",
    sort: "asc",
  },
  {
    label: "Código único",
    field: "uniqueCode",
    sort: "asc",
  },
  {
    label: "IP inicio",
    field: "ipStart",
    sort: "asc",
  },
  {
    label: "IP fin",
    field: "ipEnd",
    sort: "asc",
  },
];

const formatBooleanDisplay = (value) => {
  if (value === null || value === undefined || value === "") {
    return "Sin dato";
  }
  return value === 1 || value === "1" || value === true ? "Sí" : "No";
};

const DetalleUsuariosInstitutos = () => {
  const history = useHistory();
  const location = useLocation();
  const usuarios = Array.isArray(location.state?.usuarios) ? location.state.usuarios : [];
  const institutoNombre =
    location.state?.institutoNombre ?? location.state?.nombre ?? "Instituto sin nombre";

  const usuarioRows = useMemo(
    () =>
      usuarios.map((user, index) => ({
        index: index + 1,
        username: user.username || "Sin dato",
        email: user.email || "Sin dato",
        nombreCliente: user.nombreCliente || "Sin dato",
        boletin: user.boletin !== undefined && user.boletin !== null ? user.boletin : "Sin dato",
        mayorEdad: formatBooleanDisplay(user.mayorEdad),
        paisIndividual: user.paisIndividual || "Sin dato",
        fechaCreacion: user.fechaCreacion || "Sin dato",
        celular: user.celular || "Sin dato",
        identificador: user.identificador || "Sin dato",
        uniqueCode: user.uniqueCode || "Sin dato",
        ipStart: user.ipStart || "Sin dato",
        ipEnd: user.ipEnd || "Sin dato",
      })),
    [usuarios]
  );

  const handleBack = () => {
    history.push("/consultas/lista-institutos");
  };

  return (
    <>
      <div className="mb-4 d-flex align-items-center">
        <div className="admin-page-tilte">(</div>
        <TvIcon />
        <div className="admin-page-tilte mr-2">)</div>
        <div className="admin-page-tilte">Usuarios personales por instituto</div>
      </div>
      <Container fluid>
        <Row>
          <Col xs={12} className="d-flex justify-content-end mb-3">
            <CustomGreenButton onClick={handleBack}>
              <ArrowBackIcon fontSize="small" className="mr-2" />
              Regresar a institutos
            </CustomGreenButton>
          </Col>
        </Row>
        <Row>
          <Col xs={12} className="content-white-box px-4 py-4">
            <div className="d-flex align-items-center">
              <PersonIcon />
              <div className="admin-main-title-dark-gray ml-2 mt-1">
                {usuarios.length > 0
                  ? `Usuarios asociados a ${institutoNombre} (${usuarios.length})`
                  : "Sin usuarios para mostrar"}
              </div>
            </div>
            <div className="admin-muted-text-small mt-1 mb-3">
              {usuarios.length > 0
                ? "Detalle de los usuarios personales vinculados a este instituto."
                : "Vuelve a la lista de institutos y selecciona un registro con usuarios disponibles."}
            </div>
            {usuarios.length > 0 ? (
              <MDBDataTableV5
                small
                responsive
                striped
                bordered
                searchTop
                searchBottom={false}
                barReverse
                pagingTop
                data={{
                  columns: USER_TABLE_COLUMNS,
                  rows: usuarioRows,
                }}
                noBottomColumns
                order={["index", "asc"]}
                entriesOptions={[5, 10, 20, 50]}
                entriesLabel="Numero de filas"
                searchLabel="Buscar"
                paginationLabel={["Anterior", "Siguiente"]}
                infoLabel={["Mostrando filas", "a", "de", "filas"]}
                fullPagination
              />
            ) : (
              <div className="admin-muted-text-small">
                No se encontraron usuarios personales para este instituto. Utiliza el botón “Regresar
                a institutos” para seleccionar otro registro.
              </div>
            )}
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default DetalleUsuariosInstitutos;



